import React, { useState, Dispatch, SetStateAction } from 'react';
import Modal, { ModalBody, ModalHeader } from '../../components/bootstrap/Modal';
import Card, { CardBody } from '../../components/bootstrap/Card';
import Button from '../../components/bootstrap/Button';
import Icon from '../../components/icon/Icon';

interface Branch {
	UserAccessBranchID: number | string;
	UserAccessBranchName: string;
	UserAccessBranchUniqueID?: string;
	BranchLatitude?: string;
	BranchLongitude?: string;
	IsSelected?: number | string;
}

interface BranchSelectionModalProps {
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
	branches: Branch[];
	onBranchSelect: (branch: Branch) => void;
}

const BranchSelectionModal: React.FC<BranchSelectionModalProps> = ({
	isOpen,
	setIsOpen,
	branches,
	onBranchSelect,
}) => {
	const [selectedBranch, setSelectedBranch] = useState<Branch | null>(null);

	const handleSelectBranch = (branch: Branch) => {
		setSelectedBranch(branch);
	};

	const handleConfirm = () => {
		if (selectedBranch) {
			onBranchSelect(selectedBranch);
			setIsOpen(false);
		}
	};

	return (
		<Modal
			isOpen={isOpen}
			setIsOpen={setIsOpen}
			isCentered
			isStaticBackdrop
			size='lg'
			isAnimation>
			<ModalHeader setIsOpen={setIsOpen}>
				<div className='w-100 d-flex justify-content-center position-relative'>
					<h4 className='modal-title mb-0'>Select Branch</h4>
				</div>
			</ModalHeader>
			<ModalBody>
				<div className='mb-3'>
					<p className='text-muted text-center'>
						You have access to multiple branches. Please select a branch to continue.
					</p>
				</div>
				<div className='row g-3 justify-content-center'>
					{branches.map((branch, index) => (
						<div key={branch.UserAccessBranchID || index} className='col-md-6 col-lg-4'>
							<Card
								className={`cursor-pointer h-100 ${
									selectedBranch?.UserAccessBranchID === branch.UserAccessBranchID
										? 'border-primary shadow-sm'
										: ''
								}`}
								onClick={() => handleSelectBranch(branch)}
								style={{
									transition: 'all 0.3s ease',
									border:
										selectedBranch?.UserAccessBranchID === branch.UserAccessBranchID
											? '2px solid #0d6efd'
											: '1px solid #dee2e6',
								}}>
								<CardBody className='d-flex flex-column align-items-center text-center p-4'>
									<div
										className={`mb-3 p-3 rounded-circle ${
											selectedBranch?.UserAccessBranchID === branch.UserAccessBranchID
												? 'bg-primary'
												: 'bg-light'
										}`}
										style={{
											width: '60px',
											height: '60px',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										}}>
										<span
											style={
												selectedBranch?.UserAccessBranchID === branch.UserAccessBranchID
													? { color: '#ffffff' }
													: undefined
											}>
											<Icon
												icon='Business'
												size='2x'
												color={
													selectedBranch?.UserAccessBranchID === branch.UserAccessBranchID
														? undefined
														: 'primary'
												}
											/>
										</span>
									</div>
									<h5 className='mb-2 fw-bold'>
										{branch.UserAccessBranchUniqueID && branch.UserAccessBranchName
											? `${branch.UserAccessBranchUniqueID}-${branch.UserAccessBranchName}`
											: branch.UserAccessBranchName}
									</h5>
									{selectedBranch?.UserAccessBranchID === branch.UserAccessBranchID && (
										<div className='mt-2'>
											<Icon icon='CheckCircle' color='primary' size='lg' />
										</div>
									)}
								</CardBody>
							</Card>
						</div>
					))}
				</div>
				<div className='mt-4 d-flex justify-content-center'>
					<Button
						color='primary'
						onClick={handleConfirm}
						isDisable={!selectedBranch}
						className='px-5'>
						Continue
					</Button>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default BranchSelectionModal;

